// extracted by mini-css-extract-plugin
module.exports = {"Root":"Completed_Root__TG4vU","MetaRoot":"Completed_MetaRoot__C_aqk"};